module.exports = __webpack_public_path__ + "img/rutx14.64fc437.gif";